import React from "react";
import ElementValues, {FormatValue, getValue, measureValue} from "./Helpers";
import ProductObject from "../../controllers/ProductObject";
import MeasureValue from "../../controllers/MeasureValue";
import {PlayFieldColumn} from "./playFieldState";
import MeasurementUnit from "../../controllers/MeasurementUnit";

export const TotalsRow: React.FC<{
    label: string;
    totals: MeasureValue[];

    /**
     * Optional array of elements displayed at the end
     * (your “ElementValues”)
     */
    elementTotals?: ProductObject<MeasureValue>;

    /** The columns that define how many <td> we render. */
    columns: PlayFieldColumn[];

    /** The app's unit system, for getValue(...) calls. */
    system: MeasurementUnit;

    pricing: boolean;
    
    show: (index: number) => boolean;
    
    emptyColor: string;
}> = (props) => {

    return (
        <tr className="bg-gray-300 font-bold">
            <td className="border bg-1"/>
            <td className="border bg-3 text-gray-800">{props.label}</td>

            {props.columns.map((column, i) => {
                
                // ignore pricing columns completely if pricing is disabled
                if (column.type == 'pricing' && !props.pricing) {
                    return null;
                }
                
                if (column.type === 'column' && props.show(i)) {

                    const s = props.totals[column.index] ?? measureValue(0, 0)
                    return (
                        <td key={i} className="border">
                            <FormatValue
                                emptyColor={props.emptyColor}
                                value={getValue(props.system, s)}
                                                            />
                        </td>
                    )
                }

                return (
                    <td key={i} className="border">
                    </td>
                )
            })}

            {props.elementTotals && (
                <ElementValues
                    system={props.system}
                    values={props.elementTotals}
                    emptyColor={props.emptyColor}
                />
            )}
        </tr>
    )
}